import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router'

import { mapHash } from './Map/utils'
import { InfoPanelMaxHeigth } from './InfoPanelView'


import { useIsMobile, useHaveInfoPanel } from '../slices/ui'
import { useSettings } from '../slices/settings'
import { setMapExtent, setMapPadding, useMapFeatures } from '../slices/map'

import { useUrlParams } from '../hooks'
import { useRoute, useWaypoint } from '../api'

const MapManager = (props) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const { trail_id, route_id, accommodationList } = useUrlParams()
  const { zoom } = useSettings()
  const route = useRoute({ routeId: route_id })
  const features = useMapFeatures()
  const isMobile = useIsMobile()
  const haveInfoPanel = useHaveInfoPanel()
  const waitForFeatures = !!accommodationList && (!features || features.length == 0)


  useEffect(()=>{

    const padding = isMobile ? {
      left: 70, 
      top: 70, 
      right: 70, 
      bottom: (trail_id) ? 190 : 20
    } : {
      left: 650 * zoom, 
      top: 100 * zoom, 
      right: 100 * zoom, 
      bottom: (trail_id) ? 250 : 50
    }

    if (haveInfoPanel){
        padding.bottom = InfoPanelMaxHeigth()
    }

    dispatch(setMapPadding(padding))
  }, [isMobile, trail_id, zoom, haveInfoPanel])


  useEffect(() => {
    if (mapHash.test(history.location.hash) || (!route && !features) || waitForFeatures) {
      return
    }

    let extent, bestFitBaering

    if (features && features.length > 0){
      const x = features.map((x) => x.lnglat[0])
      const y = features.map((x) => x.lnglat[1])
      extent = [Math.min(...x), Math.min(...y), Math.max(...x), Math.max(...y)]
    } else if (trail_id) {
      extent = route.trails[trail_id - 1].extent
      bestFitBaering = route.trails[trail_id - 1].start_place.lnglat
    } else {
      extent = route.extent
      bestFitBaering = route.trails[0].start_place.lnglat
    }
    
    dispatch(setMapExtent({
      bounds: extent, 
      bestFitBaering: bestFitBaering
    }))
  }, [dispatch, history, location.pathname, trail_id, route, features, waitForFeatures])

  return null
}

export default MapManager
